import api from './api';

export async function fetchCalendarEntries({ from, to }) {
    const { data } = await api.get('/calendar', {
        params: { from, to },
    });
    return Array.isArray(data) ? data : [];
}

export async function upsertCalendarEntry(date, payload) {
    const { data } = await api.put(`/calendar/${date}`, payload);
    return data;
}

export async function deleteCalendarEntry(date) {
    await api.delete(`/calendar/${date}`);
}
